<template>
    <div id="capacitacion">
        <el-row :gutter="20" type="flex" justify="center" align="middle">
            <el-col :span="18" class="titulo">
                Capacitación # {{ idComision }} - {{ Nombre }}
            </el-col>
        </el-row>
        <el-row :gutter="20" type="flex" justify="center" align="middle">
            <el-col :span="22" class="cuerpo">
                
                <el-row justify="center" id="GridCapacitacion">                    

                    <!-- Datos -->
                    <el-col :span="24">
                        <div class="columna">
                            <strong>
                                <center><i class="el-icon-warning"></i>&nbsp;&nbsp;Datos</center>
                            </strong>
                            <hr>
                            <span style="font-size:large">
                                <strong>Código de Inscripción: </strong> {{ idInscripcion }}
                            </span>
                            <br><br>
                            <strong>Capacitación:</strong> # {{ idCapacitacion }}<br>
                            <strong>Comisión:</strong> # {{ idComision }}<br>
                            <strong>Área:</strong> {{ Area }}<br>
                            <strong>Disciplina:</strong> {{ Disciplina }}<br>
                            <strong>Linea de acción:</strong> {{ Linea }}<br><br>

                            <strong>Lugar:</strong> {{ Lugar }}<br>
                            <strong>Duración:</strong> {{ Duracion }} encuentros<br>
                            <strong>Carga horaria total:</strong> {{ Horas }} horas catedra<br><br>

                            <strong>Fecha de inicio:</strong> {{ Inicio }}<br>
                            <strong>Fecha de finalización:</strong> {{ Fin }}<br>
                        </div>
                    </el-col>


                    <!-- Horarios -->
                    <el-col :span="24">
                        <div class="columna">
                            <strong>
                                <center><i class="el-icon-date"></i>&nbsp;&nbsp;Horarios</center>
                            </strong>
                            <hr>
                            <div v-if="Horario" style="margin-bottom:15px">
                                <strong>{{ Horario }}</strong>
                            </div>
                            <div v-for="(item,index) in Horarios" :key="index" style="margin-bottom:15px">
                                <strong>{{ item.Fecha }}</strong>: de <strong>{{ item.Entrada }}</strong> a
                                <strong>{{ item.Salida }}</strong><span v-if="item.Sede"> en <strong>{{ item.Sede }}</strong></span>.
                            </div>
                        </div>
                    </el-col>
                    
                    
                    <!-- Codigo QR --><!-- Inscripcion -->
                    <el-col :span="24" v-if="Inscripcion">
                        <div class="columna">
                            <strong>
                                <center><i class="el-icon-download"></i>&nbsp;&nbsp;Código de Inscripción</center>
                            </strong>
                            <hr>
                            <embed style="width:100%; min-height:42vh; overflow-x:hidden; overflow-y:hidden"
                            :src="'https://docentes.educaciondigitaltuc.gob.ar/embed/com_qr.php?idDCC=' + idInscripcionEncriptada + ''">
                        </div>
                    </el-col>                    


                    <!-- Acreditacion -->
                    <el-col :span="24" v-if="Acreditacion">
                        <div class="columna">
                            <strong>
                                <center><i class="el-icon-time"></i>&nbsp;&nbsp;Acreditación</center>
                            </strong>
                            <div v-for="(item,index) in Acreditacion" :key="index" style="margin-bottom:15px">
                                <hr>
                                <strong>Fecha: </strong>{{ item.Fecha }}<br>
                                <strong>Entrada: </strong>{{ item.Entrada }}<br>
                                <strong>Salida: </strong>{{ item.Salida }}<br>
                            </div>
                        </div>
                    </el-col>


                    <!-- Estado -->
                    <el-col :span="24">
                        <div class="columna">
                            <strong>
                                <center><i class="el-icon-document"></i>&nbsp;&nbsp;Estado</center>
                            </strong>
                            <hr>
                            <center style="font-size:large">{{ Estado }}</center>
                            <button v-if="Baja" class="el-button el-button--warning" style="width:100%; margin-top:10px"
                            v-on:click="Confirmar()">
                                <strong><i class="el-icon-error"></i>&nbsp;&nbsp;&nbsp;Baja</strong>
                            </button>  <!-- Estado=='Aprobado' -->
                            <a v-if="Estado=='Aprobado'"
                            class="el-button el-button--success" target="_blank" style="width:100%; margin-top:20px"
                            :href="'https://docentes.educaciondigitaltuc.gob.ar/embed/com_const.php?tkn='+ TK +'&c=' + idComisionEncriptada + ''">
                                <strong><i class="el-icon-star-on"></i>&nbsp;&nbsp;&nbsp;Descargar Constancia</strong>
                            </a>
                        </div>
                    </el-col>


                    <!-- Certificado -->
                    <el-col :span="24">
                        <div class="columna">
                            <strong>
                                <center><i class="el-icon-tickets"></i>&nbsp;&nbsp;Certificado</center>
                            </strong>
                            <hr>
                            <center style="font-size:large">{{ Certificado }}</center>
                        </div>
                    </el-col>


                    <!-- Credencial -->   <!-- Credencial -->
                    <el-col :span="24" v-if="Credencial">
                        <div class="columna" style="padding-top:0px">
                            <div style="padding:20px 20px 0% 20px">
                                <strong>
                                    <center><i class="el-icon-printer"></i>&nbsp;&nbsp;Credencial</center>
                                </strong>
                                <hr>
                            </div>
                            <embed style="width:100%; min-height:320px"
                            :src="'https://docentes.educaciondigitaltuc.gob.ar/embed/com_cred.php?tkn='+ TK +'&dcc=' + idInscripcionEncriptada + ''">
                            <a class="el-button el-button--primary" target="_blank" style="width:100%"
                            :href="'https://docentes.educaciondigitaltuc.gob.ar/embed/com_cred_imp.php?tkn='+ TK +'&dcc='+ idInscripcionEncriptada +''">
                                Descargar Credencial
                            </a>
                        </div>
                    </el-col> 

                </el-row>


                <!-- Archivos -->
                <el-row v-if="Archivo">
                    <el-col :span="24">
                        <div class="columna" style="padding-top:0px">
                            <div style="padding:20px 20px 0% 20px">
                                <strong>
                                    <center><i class="el-icon-news"></i>&nbsp;&nbsp;Documentos Importantes</center>
                                </strong>
                                <hr>
                            </div>
                            <embed style="width:100%; min-height:320px" :src="'https://docentes.educaciondigitaltuc.gob.ar/' + Archivo"/>
                        </div>
                    </el-col>
                </el-row>


                <el-row :gutter="20" justify="space-between" style="margin-top:50px">
                    <el-col :xs="24" :sm="12" :md="8" style="float:right; margin-bottom:10px">
                        <router-link class="el-col el-col-24 el-button el-button--success" style="float:right"
                        :to="{ name: 'mensajes', params: { id: idComisionEncriptada } }">
                            <i class="el-icon-message"></i>&nbsp;&nbsp;&nbsp;Mensajes <strong>({{ Mensajes }})</strong>
                        </router-link>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="8" v-if="AulaVirtual || Campus" style="float:right">
                        <a v-if="AulaVirtual" class="el-col el-col-24 el-button el-button--violeta" target="_blank" style="margin-bottom:10px"
                        :href="'https://plataforma.educaciondigitaltuc.gob.ar/moodle/course/view.php?id='+AulaVirtual+''">
                            <i class="el-icon-service"></i>&nbsp;&nbsp;&nbsp;Aula Virtual
                        </a><br>
                        <a v-if="Campus" class="el-col el-col-24 el-button el-button--violeta" target="_blank" style="margin-bottom:10px"
                        :href="'https://campus.educaciontuc.gov.ar/lms/course/view.php?id='+Campus+''">
                            <i class="el-icon-service"></i>&nbsp;&nbsp;&nbsp;Aula Virtual
                        </a><br>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="8" style="float:left">
                        <router-link class="el-col el-col-24 el-button el-button--danger"
                        :to="{ name: 'capacitaciones' }">
                            Volver
                        </router-link>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>


<script>
    import axios from 'axios'
    import VueQr from 'vue-qr'

    export default
    {   components:
        {   VueQr
        },

        data()
        {   return {
                idComision:                 atob(this.$route.params.id),
                idComisionEncriptada:       this.$route.params.id,
                Acreditacion:               '',
                Archivo:                    '',
                Area:                       '',                
                AulaVirtual:                '',
                Baja:                       '',
                Campus:                     '',
                Certificado:                '',
                Credencial:                 '',
                Disciplina:                 '',
                Duracion:                   '',
                Estado:                     '',
                Fin:                        '',
                Horario:                    '',
                Horas:                      '',
                idCapacitacion:             '',                
                idInscripcion:              '',
                idInscripcionEncriptada:    '',
                Inicio:                     '',
                Inscripcion:                '',
                Linea:                      '',
                Lugar:                      '',
                Mensajes:                   '',
                Nombre:                     '',
                TK:                         '',
                Encuesta:                   null,
                Horarios:                   [],                
            }
        },


        methods:
        {   Confirmar( )
            {   if( confirm('¿Seguro quiere darse de baja de la Comisión?') )
                {   this.MsjSubmit();
                }
            },
            MsjSubmit( )
            {   var params  = '';
                var headers = new Headers();
                headers.append('Content-Type', 'application/x-www-form-urlencoded');

                params  = params + '&tkn=' + this.$cookies.get('PDTK');
                params  = params + '&idComision=' + btoa(this.idComision);
                params  = params + '&idDCC=' + btoa(this.idInscripcion);
                
                axios.post('https://docentes.educaciondigitaltuc.gob.ar/aphpi/com_b.php', params, {headers: headers})
                    .then(response => {
                        this.$router.push('../capacitaciones');
                    })
                    .catch(e => { })
            }
        },



        beforeMount( )
        {   if(!this.$cookies.get('PDTK'))
            {   this.$router.push('../login');
            }
            else
            {   var params  = '';
                var headers = new Headers();
                headers.append('Content-Type', 'application/x-www-form-urlencoded');

                params  = params + '&tkn=' + this.$cookies.get('PDTK');
                params  = params + '&idComision=' + btoa(this.idComision);
                
                axios.post('https://docentes.educaciondigitaltuc.gob.ar/aphpi/com.php', params, {headers: headers})
                    .then(response => {
                        const datos             = response.data;
                        if(datos['Nombre'])
                        {   this.Acreditacion   = datos['Acreditacion'];
                            this.Archivo        = datos['Archivo'];
                            this.Area           = datos['Area'];
                            this.AulaVirtual    = datos['idAulaVirtual'];   
                            this.Baja           = datos['Baja'];
                            this.Campus         = datos['idCampus'];
                            this.Certificado    = datos['Certificado'];
                            this.Credencial     = datos['Credencial'];
                            this.Disciplina     = datos['Disciplina'];
                            this.Duracion       = datos['Duracion'];
                            this.Encuesta       = datos['Encuesta'];
                            this.Estado         = datos['Estado'];
                            this.Fin            = datos['Fec_fin'];
                            this.Horario        = datos['Horario'];
                            this.Horarios       = datos['Horarios'];
                            this.Horas          = datos['Hs_catedra'];
                            this.idCapacitacion = datos['capacitacion_idCapacitacion1'];
                            this.idInscripcion  = datos['idDocCap'];
                            this.Inicio         = datos['Fec_inicio'];                            
                            this.Linea          = datos['Linea_accion']; 
                            this.Lugar          = datos['Lugar'];
                            this.Mensajes       = datos['Mensajes'];
                            this.Nombre         = datos['Nombre'];
                            this.Inscripcion    = true;
                            this.idInscripcionEncriptada = btoa(this.idInscripcion);
                            this.TK             = this.$cookies.get('PDTK');                            
                        }
                        else
                        {   this.$router.push('../capacitaciones');
                        }
                    })
                    .catch(e => {})
            }
        }
    };
</script>


<style>
    #capacitacion
    {   font-size: 15px !important;
    }
    
    #GridCapacitacion
    {   margin-left: -1%;
        margin-top: 2%;
        width: 98%;
        column-count: 3;
        padding: 0px;
    }
    @media screen and (max-width: 900px)
    {   #GridCapacitacion
        {   column-count: 3;
        }
    }
    @media screen and (max-width: 800px)
    {   #GridCapacitacion
        {   column-count: 2;
        }
    }
    @media screen and (max-width: 500px)
    {   #GridCapacitacion
        {   column-count: 1;
        }
    }


    .columna
    {   width: 100%;
        background-color: rgba(255,255,255,0.5);
        padding: 20px;
        display: inline-block;
        margin-bottom: 20px;
    }

    .el-button--violeta, .el-button--violeta:active, .el-button--violeta:focus
    {   background: #788EDC;
        border: 1px solid #788EDC;
        color: #fff;
    }
    .el-button--violeta:hover
    {   background: #879bdb;
        border: 1px solid #879bdb;
        color: #fff;
    }
</style>
